import type { ReportGroup } from "../../../../../../api/types/svTypes.ts";
import type { SideMenuFilter } from "../components/ReportsSideMenu.tsx";

export interface SideMenuItemFields {
  group: string;
  groupOrder: number;
  isFavorite: boolean;
}

export const getSideMenuItemFields = (group: ReportGroup | undefined, isFavorite: boolean): SideMenuItemFields => ({
  group: group?.caption ?? "",
  groupOrder: group?.order ?? Number.MAX_VALUE,
  isFavorite,
});

export const getActiveSideMenuFilter = (filter: SideMenuFilter, groups: ReportGroup[]): SideMenuFilter =>
  filter === "all" || filter === "favorites" || groups.some((group) => group.id === filter) ? filter : "all";

export const isInSideMenuFilter = (filter: SideMenuFilter, item: { groupId: string; isFavorite: boolean }): boolean => {
  if (filter === "all") {
    return true;
  }
  if (filter === "favorites") {
    return item.isFavorite;
  }
  return item.groupId === filter;
};

export const getSideMenuFilterLabel = (
  filter: SideMenuFilter,
  groups: ReportGroup[],
  allItemsLabel: string
): string => {
  if (filter === "favorites") {
    return "My Favorites";
  }
  return groups.find((group) => group.id === filter)?.caption ?? allItemsLabel;
};
